import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-50 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <h3 className="text-3xl font-light text-foreground-950 font-heading mb-4">
              订阅第一手瓜
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6">
              每天推送最新爆料，让你不错过任何大瓜。全网最全吃瓜平台，实时追踪，独家揭秘。
            </p>
            <form
              id="subscribe"
              data-readdy-form
              action="https://readdy.ai/api/form/d917ms8bhec1he3opq20"
              method="POST"
              encType="application/x-www-form-urlencoded"
            >
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱获取每日更新"
                  required
                  className="flex-1 bg-transparent border-b border-primary-500/50 focus:border-primary-500 outline-none text-foreground-950 text-sm py-2 px-0 transition-colors duration-200 placeholder:text-foreground-400"
                />
                <button
                  type="submit"
                  className="bg-foreground-950 text-background-50 px-6 py-2 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-foreground-800 transition-all duration-200 cursor-pointer flex items-center gap-2"
                >
                  立即订阅
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              <div className="honeypot-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              </div>
            </form>
          </div>

          <div>
            <h4 className="text-primary-500 text-xs font-semibold uppercase tracking-wider mb-5">
              快速导航
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 border-b border-primary-500/30 pb-1 w-fit">
                首页
              </Link>
              <Link to="/category/wanghong-heiliao" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 border-b border-primary-500/30 pb-1 w-fit">
                网红黑料
              </Link>
              <Link to="/category/mingxing-bagua" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 border-b border-primary-500/30 pb-1 w-fit">
                明星八卦
              </Link>
              <Link to="/about" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 border-b border-primary-500/30 pb-1 w-fit">
                关于我们
              </Link>
              <a href="#subscribe" className="text-foreground-600 hover:text-primary-500 text-sm transition-colors duration-200 border-b border-primary-500/30 pb-1 w-fit">
                投稿爆料
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-primary-500 text-xs font-semibold uppercase tracking-wider mb-5">
              联系我们
            </h4>
            <div className="flex flex-col gap-3 text-sm">
              <p className="text-foreground-950 font-medium">010-8888-6666</p>
              <p className="text-foreground-600">tips@02office.cn</p>
              <div className="mt-4">
                <h4 className="text-primary-500 text-xs font-semibold uppercase tracking-wider mb-3">
                  办公地址
                </h4>
                <p className="text-foreground-600 leading-relaxed">
                  北京市朝阳区望京SOHO<br />T3-A座 2808室
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 underline underline-offset-2 cursor-pointer">
              微博
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 underline underline-offset-2 cursor-pointer">
              微信
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 underline underline-offset-2 cursor-pointer">
              抖音
            </a>
          </div>
          <p className="text-foreground-500 text-xs text-center">
            &copy; 2026 爆料网 BaoLiao.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 hover:text-primary-500 text-xs transition-colors duration-200 underline underline-offset-2 cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 text-xs transition-colors duration-200 underline underline-offset-2 cursor-pointer">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
